import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import Fade from 'react-reveal/Fade';

import e1 from '../../../img/Home/e1.svg';
import e2 from '../../../img/Home/e2.svg';
import e3 from '../../../img/Home/e3.svg';
import e4 from '../../../img/Home/e4.svg';
import e5 from '../../../img/Home/e5.svg';
import e6 from '../../../img/Home/e6.svg';
import e7 from '../../../img/Home/e7.svg';
import e8 from '../../../img/Home/e8.svg';
import e9 from '../../../img/Home/e9.svg';

import { useTradingData } from './useTradingData';

const tabs = [
  { name: 'Крипто', icon: e1 },
  { name: 'Популярные инструменты', icon: e2 },
  { name: 'Акции', icon: e3 },
  { name: 'Сырьевые товары', icon: e4 },
  { name: 'Индексы', icon: e5 },
  { name: 'Валюта', icon: e6 },
  { name: 'Опционы', icon: e7 },
  { name: 'ETF', icon: e8 },
  { name: 'Лидеры роста и падения', icon: e9 }
];

function EndlessTrading() {
  
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(tabs[0].name);

  const { data, loading } = useTradingData(activeTab);

  return (
    <div className="relative max-w-[1920px] mx-auto xl:pt-[200px]">
      <div className="max-w-[1220px] xl:mx-auto mx-[20px]">
        <div className="h-[470px] xl:w-[1220px] bg-[#0C2780] rounded-[20px] rotate-[6.275deg] absolute hidden xl:block"></div>
        <div className="relative xl:px-[70px] pt-[80px] flex flex-col xl:flex-row justify-between">
          <div className='hidden xl:block'>
            <p className="open-sans text-[19px] font-[600] text-white">{t('home.5')}</p>
            <p className="text-[45px] font-[700] text-[#63ABFF] open-sans">{t('home.6')}</p>
            <p className="xl:max-w-[443px] open-sans text-[14px] xl:text-[16px] font-[300] text-white mt-[30px]">{t('home.7')}</p>
          </div>
          <div className='block xl:hidden'>
            <p className='font-[700] text-[23px] text-[#0C2780] open-sans'>{t('home.8')}</p>
            <p className="xl:max-w-[443px] open-sans text-[14px] xl:text-[16px] font-[300] text-[#0C2780] xl:text-white mt-[25px]">{t('home.7')}</p>
          </div>
          <Fade bottom>
            <div className='mt-[40px] xl:mt-0'>
              <div className="flex sm:gap-x-[10px] xl:gap-x-0 xl:justify-between items-end h-[45px]">
                {tabs.map(tab => (
                  <button
                    key={tab.name}
                    onClick={() => setActiveTab(tab.name)}
                    className={`rounded-t-[10px] px-3 py-2 transition-all ${activeTab === tab.name ? 'bg-white h-[45px]' : 'bg-white opacity-[0.7] h-[38px]'}`}
                  >
                    <img src={tab.icon} alt={tab.name} className={`${activeTab === tab.name ? 'w-[35px] h-[35px]' : 'w-[24px] h-[24px]'}`} />
                  </button>
                ))}
              </div>
              <div className="xl:w-[486px] h-[420px] xl:h-[450px] bg-white rounded-b-[15px] text-[11px] sm:text-[14px]">
                <div className="p-4">
                  <div>
                    {loading ? (
                      <div>Загрузка...</div>
                    ) : (
                      <table className="min-w-full">
                        <tbody>
                          {Array.isArray(data) && data.slice(0, 10).map((item, index) => (
                            <tr key={index}>
                              <td className="sm:px-2 pt-[12px]">
                                <img src={item.image} className="rounded-[10px] w-[35px] h-[35px] object-cover max-w-max" alt={item.name} />
                              </td>
                              <td className="px-1 sm:px-2 pt-[12px] text-[#15318D] font-[600] open-sans">{item.name}</td>
                              <td className="px-1 sm:px-2 pt-[12px] font-[600] open-sans">
                                {item.current_price || item.price || '—'}
                              </td>
                              <td className="pt-[12px] px-2 open-sans">
                                {typeof item.price_change_percentage_24h === 'number' && (
                                  <span
                                    className={`ml-2 font-[600] ${item.price_change_percentage_24h >= 0 ? 'text-green-600' : 'text-red-600'}`}
                                  >
                                    ({item.price_change_percentage_24h.toFixed(2)}%)
                                  </span>
                                )}
                              </td>
                              <td className="hidden sm:block sm:px-2 pt-[12px] hover:scale-[1.1] transition-all">
                                <a href='https://user.arvest-solid.net' target="_blank" rel="noreferrer" className="text-[#15318D] open-sans font-[300] border rounded-[20px] px-[10px] py-[4px] transition-all border-[#15318D]">Торговля</a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
}

export default EndlessTrading;
